import React from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import useStyles from "../../dashAuction.style";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import buyerDetailsAPI from "../../../../../api/adminAPI/buyerDetailsAPI";
import { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import moment from "moment";
import {
  getToken,
  getUserData,
  getTimeZone,
  localTimeZone,
  localSetTimeZone,
} from "../../../../../common";
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";

import lodash from "lodash";
import { FaRegFileExcel } from "react-icons/fa";
import * as XLSX from "xlsx";
import { DATE_TIME_DISPLAY, dateSortValue } from "../../../../../common/dateTime";

function DashBuyerDetail({ DashEventDetail, BidlogFirst, buyerId }) {
  const classes = useStyles();

  const getZone = getTimeZone() ? getTimeZone() : localTimeZone();

  const [tableBuyersData, setTableBuyersData] = useState([]);
  const [BuyerDetails, setBuyerDetails] = useState([]);

  const buyersDetails = async (buyerId) => {
    try {
      const { data } = await buyerDetailsAPI(buyerId);

      if (data) {
        let id = 1;
        const buyersData = data.buyerWiseEvents.map((data, index) => {
          return {
            id: id++,
            seller: data.seller,
            auctionId: data.auctionId,
            eventName: data.eventName,
            sDateNtimeSortValue: dateSortValue(data.startDateTime),
            sDateNtime: moment(data.startDateTime)
              .tz(getZone)
              .format(DATE_TIME_DISPLAY),
            eDateNtimeSortValue: dateSortValue(data.endDateTime),
            eDateNtime: moment(data.endDateTime)
              .tz(getZone)
              .format(DATE_TIME_DISPLAY),
            numLots: data.totalLots,
            lotOwner: data.ownerOfLots,
            allotedLot: data.allotedLots,
            bidLot: data.bidedLots,
            location: data.location,
            eventId: data.eventId,
          };
        });

        setTableBuyersData(buyersData);
        setBuyerDetails(data.buyerDetails);
      } else throw new Error(data);
    } catch (error) {
      console.log(error);
    }
  };
  React.useEffect(() => {
    buyersDetails(buyerId);
    return () => {
      return false;
    };
  }, [buyerId]);

  const nextColumns = [
    {
      name: "Sr.",
      selector: (row) => Number(row.id),
      sortable: true,
      width: "70px",
    },
    {
      name: "Seller",
      selector: (row) => row.seller || "-",
      sortable: true,
    },
    {
      name: "Auction ID",
      selector: (row) => row.auctionId,
      sortable: true,
    },
    {
      name: "Event Name",
      selector: (row) => row.eventName,
      cell: (row) => (
        <Tooltip
          title={row.eventName}
          placement="top-start"
          TransitionComponent={Zoom}
        >
          <span className={classes.ellipsisText}>{row.eventName}</span>
        </Tooltip>
      ),
      sortable: true,
    },
    {
      name: "Start Date & Time",
      selector: (row) => row.sDateNtimeSortValue,
      cell: (row) => row.sDateNtime,
      sortable: true,
    },
    {
      name: "End Date & Time",
      selector: (row) => row.eDateNtimeSortValue,
      cell: (row) => row.eDateNtime,
      sortable: true,
    },
    {
      name: "No. of Lots",
      selector: (row) => Number(row.numLots),
      sortable: true,
    },
    {
      name: "Lot Owner",
      selector: (row) => row.lotOwner || "-",
      cell: (row) => (
        <Tooltip
          title={row.lotOwner}
          placement="top-start"
          TransitionComponent={Zoom}
        >
          <span className={classes.ellipsisText}>{row.lotOwner}</span>
        </Tooltip>
      ),
      sortable: true,
    },
    {
      name: "Alloted Lots",
      selector: (row) => Number(row.allotedLot),
      sortable: true,
    },
    {
      name: "Bidded Lots",
      selector: (row) => Number(row.bidLot),
      sortable: true,
    },
    {
      name: "Location",
      selector: (row) => row.location || "-",
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <div>
          <Button
            className="btn btn-group"
            onClick={() => {
              DashEventDetail(buyerId, row.eventId);
            }}
          >
            View
          </Button>
        </div>
      ),
    },
  ];

  const exportToXLSX = (tableData, tableHeader) => {
    const headerColumns = lodash.map(tableHeader, ({ name }) => {
      if (name != "Action") {
        return name;
      }
    });
    const dataColumns = lodash.map(tableData, (columns) => [
      columns.id,
      columns.seller,
      columns.auctionId,
      columns.eventName,
      columns.sDateNtime,
      columns.eDateNtime,
      columns.numLots,
      columns.lotOwner,
      columns.allotedLot,
      columns.bidLot,
      columns.location,
    ]);

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet([headerColumns, ...dataColumns]);

    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "buyer-wise-event.xlsx");
  };

  const ExportButton = () => (
    <Button onClick={() => exportToXLSX(tableBuyersData, nextColumns)}>
      <FaRegFileExcel
        style={{ fontSize: "30px", color: "#04aa18", paddingTop: "4px" }}
      />
    </Button>
  );

  return (
    <>
      <div className="topDetail">
        <div className="row">
          <div className="col-md-6 m-auto">
            <h3>
              <Button sx={{ color: "#000" }} onClick={BidlogFirst}>
                <ArrowBackIcon />
              </Button>
              Buyer Details
            </h3>
          </div>
          <div className="col-md-6">
            <div className={classes.detailCard}>
              <div className="row">
                <div className="col-md-6">
                  <div className={classes.Detail}>
                    <p className={classes.SideLine}>
                      Name &nbsp; : &nbsp;{" "}
                      <span>
                        {BuyerDetails.firstName} {BuyerDetails.lastName}
                      </span>
                    </p>
                    <p
                      className={`${classes.SideLine} ${classes.marginremove}`}
                    >
                      email &nbsp; : &nbsp; <span>{BuyerDetails.email}</span>
                    </p>
                  </div>
                </div>
                <div className="col-md-6 mt-2">
                  <div className={classes.Detail}>
                    <p>
                      Mobile No.&nbsp;: &nbsp;
                      <span>{BuyerDetails.contactNumber}</span>
                    </p>
                    <p className={classes.marginremove}>
                      alternate Contact Number&nbsp;:&nbsp;{" "}
                      <span>{BuyerDetails.alternateContactNumber}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="AuctionTable">
        <h3>Buyer Wise Event</h3>
        <DataTableExtensions
          print={false}
          export={false}
          exportHeaders={false}
          columns={nextColumns}
          data={tableBuyersData}
        >
          <DataTable
            noHeader={false}
            defaultSortField="id"
            defaultSortAsc={false}
            pagination={false}
            highlightOnHover
            className="DataTable"
            actions={<ExportButton />}
          />
        </DataTableExtensions>
      </div>
    </>
  );
}

export default DashBuyerDetail;
